import React from "react";
import ArticleMainImage from "components/atoms/ArticleMainImage";
import Container from "components/atoms/Container";
import HtmlSection from "components/molecures/Sections/HtmlSection";
import SNS from "components/molecures/SNS";
import { GetArticleQuery, Position } from "API";
import AritlcesBlock from "components/organisims/articles/AritlcesBlock";
import { Box, NoSsr, Typography } from "@material-ui/core";
import ArticleDate from "components/atoms/ArticleDate";
import ArticleTags from "components/organisims/ArticleTags";
import { getCfUrl } from "settings/storageSettings";
import Header from "components/uikit/Header/Header";
import Adblock from "components/organisims/Adblock";
import { AdBannersType } from "../../../../types/adBanners";

type Article = GetArticleQuery["getArticle"];

type Props = {
  article: Article;
  realtime?: boolean;
  author?: any;
  categories: any[];
  categoryArticles: any[];
  relatedArticles: any[];
  adBanners: AdBannersType;
};

export default function Page(props: Props) {
  const {
    article,
    categoryArticles,
    relatedArticles,
    adBanners,
    categories,
  } = props;
  const isMobile = true;

  return (
    <>
      <Header
        color="white"
        brand="Kazi ONLINE"
        fixed
        changeColorOnScroll={{
          height: 0,
          color: "white",
        }}
        categories={categories}
      />
      <div style={{ paddingTop: 120 }}>
        <Container style={{ boxShadow: "none" }}>
          <div
            style={{ maxWidth: 880, marginLeft: "auto", marginRight: "auto" }}
          >
            <ArticleMainImage src={getCfUrl(article?.mainImage?.url ?? "")} />
            <h2>
              <div
                style={{
                  fontSize: isMobile ? "24px" : "30px",
                  fontWeight: "bold",
                  lineHeight: "2rem",
                }}
              >
                {article?.title}
              </div>
            </h2>

            <Box style={{ paddingRight: "8px" }}>
              <ArticleTags tags={article?.tags} showTitle={false} />
            </Box>

            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              <ArticleDate date={article?.startDateTime ?? ""} />
            </span>
            <div
              style={{
                marginTop: "2rem",
                wordBreak: "break-word",
              }}
            >
              <HtmlSection data={article?.description} />
            </div>

            {/* 記事下広告 */}
            <Adblock
              position={Position.articlefooter}
              adBanners={adBanners}
              isFullWidth
            />

            {relatedArticles && relatedArticles?.length > 0 && (
              <Box style={{ padding: "16px 0" }}>
                <Typography
                  variant="h5"
                  color="error"
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  あわせて読みたい！
                </Typography>
                <ul style={{ paddingLeft: "20px" }}>
                  {relatedArticles?.map((article) => (
                    <li
                      key={article.id}
                      style={{ fontSize: "16px", padding: "8px 0" }}
                    >
                      <a
                        href={`/articles/${article.slug}`}
                        target="_blank"
                        style={{
                          textDecoration: "none",
                          display: "block",
                          lineHeight: "1.3",
                        }}
                      >
                        {article.title}
                      </a>
                    </li>
                  ))}
                </ul>

                <style jsx>{`
                  ul li::marker {
                    color: #1076ac;
                  }
                `}</style>
              </Box>
            )}

            <hr />

            <Box style={{ paddingRight: "8px" }}>
              <ArticleTags tags={article?.tags} showTitle={true} />
            </Box>

            <NoSsr>
              <h6>この記事を SNS でシェアする</h6>
              <SNS />
            </NoSsr>

            <AritlcesBlock
              categoryArticles={categoryArticles}
              category={article?.category}
            />
          </div>
        </Container>
      </div>
    </>
  );
}
